import { Daterange } from '@northfork/ng-basics'
import { Observable } from 'rxjs'
import { AccruedInterest } from '../models/accrued-interest.model'
import { CouponRateHistory } from '../models/coupon-rate-history.model'
import { Distribution } from '../models/distribution.model'
import { DividendHistory } from '../models/dividend-history.model'
import { FactorHistory } from '../models/factor-history.model'
import { MMFCharacteristics, MMFSettings } from '../models/mmf-settings.model'
import { SecurityData } from '../models/security-data.model'

export abstract class DistributionsService {
  abstract getDistribution(
    securityId: number,
    dateRange?: Daterange | null,
  ): Observable<Distribution[]>

  abstract getFactorHistory(securityId: number): Observable<FactorHistory[]>

  abstract getCouponRateHistory(
    securityId: number,
  ): Observable<CouponRateHistory[]>

  abstract getDividendHistory(securityId: number): Observable<DividendHistory[]>

  abstract getAccruedInterestByRate(
    securityId: number,
    dateRange?: Daterange | null,
  ): Observable<AccruedInterest[]>

  abstract getAccruedInterestByAmount(
    securityId: number,
    dateRange?: Daterange | null,
  ): Observable<AccruedInterest[]>

  abstract getSecurityData(securityId: number): Observable<SecurityData>

  abstract getMMFSettings(
    securityId: number,
    accountId: number,
  ): Observable<MMFSettings>

  abstract updateMmfCharacteristics(
    mmfCharacteristics: MMFCharacteristics,
  ): Observable<string>
}
